const React = require("react");
const ButtonBack = require("../../../../dumb/Button/BackB");
const Caption = require("../../../../dumb/Caption/C");

const FormWallet = require('../FormWallet');
const {pushLocation, backLocation} = require("../../../../../router");
const {apiV2CryptoWalletCreate} = require("../../../../../api/merchant/cryptoWallet");
const {paramStore} = require("../../../../../stores");
const {LINK_WITHDRAW} = require("../../../../../constants/links");

module.exports = (props) => {
  const appId = props.params.appId;
  const backPath = paramStore('backPath').getValue();
  const asset = paramStore('asset').getValue();

  const backFN = backPath
    ? (props) => {
      if (backPath === 'withdraw') {
        const params = appId && props.id ? `?appId=${appId}&walletId=${props.id}` : '';

        pushLocation({
          path: `${LINK_WITHDRAW}/${asset}${params}`
        })
       return;
      }

      backLocation()
    }
    : backLocation

  const request = (props) => apiV2CryptoWalletCreate(props).then(backFN);

  return (
    <div>
      <div className="layoutRow fhaB fvaC">
        <ButtonBack
          className="m-10 mr10"
          onClick={backFN}
        />
        <Caption>
          Add new crypto wallet
        </Caption>
      </div>
      <div>
        <FormWallet
          appId={appId}
          asset={asset}
          request={request}
          resultText={[
            'Wallet created',
            'We\'ve saved wallet data. Now your users will be able to send tokens to this address.'
          ]}
        />
      </div>
    </div>
  );
}
